import { getLaunchAppConfigV2 } from '../webx';
import { getCurrentPageParams, PULL_EVENE_TYPE_MAP } from '@didi/webx-js-core';
import { getLaunchAppCommonParams } from './utils/common';
import { storage } from '../storage';
import { query } from '../query';
export const launchAppInitParams = {}; // 缓存批量入参map
export const launchAppInitData = {}; // 批量缓存拉端策略
// 获取拉端策略数据
const getLaunchAppInfo = (getConfigOptions, extraParams) => new Promise((resolve) => {
    const { env, refId, launchAppDchn, launchAppXsc, morePriority, isUseWeixinTag, isCopyCmd, cmdText, cmdParams, phone, keyboardToken, invokeMode, } = getConfigOptions;
    const { launchAppConfig } = storage;
    const urlParams = query();
    const params = {
        args: {
            invoke_params: [{
                    pull_event_type: PULL_EVENE_TYPE_MAP.BTN_CLICK,
                    dchn: launchAppDchn,
                    xsc: launchAppXsc,
                    phone,
                    invoke_mode: invokeMode || 'click',
                    uid_web: window.localStorage.getItem('uid_web') || '',
                    keyboard_token: keyboardToken,
                    more_priority: morePriority || [],
                    is_use_weixin_tag: isUseWeixinTag || false,
                    is_copy_cmd: isCopyCmd || false,
                    cmd_text: cmdText || '',
                    cmd_params: { ...cmdParams }
                }],
            params: {
                ...getCurrentPageParams(urlParams),
                ...extraParams
            }
        },
        ...getLaunchAppCommonParams()
    };
    const cacheData = launchAppInitData[refId];
    if (cacheData) {
        resolve(cacheData);
        return;
    }
    if (launchAppConfig[refId]) {
        launchAppInitData[refId] = launchAppConfig[refId];
        resolve(launchAppConfig[refId]);
        return;
    }
    getLaunchAppConfigV2(params, env || 'online').then((res) => {
        const newData = res?.conf?.[0] || {};
        launchAppInitData[refId] = newData;
        resolve(newData);
    });
});
const getLaunchAppInfoBatch = (getConfigOptionsArr, extraParams) => new Promise((resolve) => {
    const invokeParams = [];
    const { launchAppConfig } = storage;
    const urlParams = query();
    getConfigOptionsArr.forEach(obj => {
        const { env, refId, launchAppDchn, launchAppXsc, morePriority, isUseWeixinTag, isCopyCmd, cmdText, cmdParams, phone, keyboardToken, invokeMode, } = obj;
        if (launchAppConfig[refId]) {
            launchAppInitData[refId] = launchAppConfig[refId];
        }
        else {
            invokeParams.push({
                env,
                refId,
                pull_event_type: PULL_EVENE_TYPE_MAP.BTN_CLICK,
                dchn: launchAppDchn,
                xsc: launchAppXsc,
                phone,
                invoke_mode: invokeMode || 'click',
                uid_web: window.localStorage.getItem('uid_web') || '',
                keyboard_token: keyboardToken,
                more_priority: morePriority || [],
                is_use_weixin_tag: isUseWeixinTag || false,
                is_copy_cmd: isCopyCmd || false,
                cmd_text: cmdText || '',
                cmd_params: { ...cmdParams },
            });
        }
    });
    if (invokeParams.length < 1) {
        resolve(launchAppInitData);
        return;
    }
    const params = {
        args: {
            invoke_params: invokeParams,
            params: {
                ...getCurrentPageParams(urlParams),
                ...extraParams
            }
        },
        ...getLaunchAppCommonParams()
    };
    getLaunchAppConfigV2(params, invokeParams?.[0]?.env || 'online').then((res) => {
        const launchAppRes = res?.conf || [];
        launchAppRes.forEach((obj, index) => {
            launchAppInitData[invokeParams[index]?.refId] = obj;
        });
        resolve(launchAppInitData);
    });
});
export { getLaunchAppInfo, getLaunchAppInfoBatch, };
